'use strict';

exports.__esModule = true;
exports.GROUP_CONSUMER = exports.GROUP_PARTNER = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _faustClient = require('../network/faust-client');

var _faustClient2 = _interopRequireDefault(_faustClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  VERSIONED_DOCUMENTS: '/versioned_documents',
  MISSING_SIGNATURES: '/missing_signatures',
  SIGN_DOCUMENTS: '/versioned_document_signatures',
  COMMUNICATION_TYPES: '/communication_types',
  COMMUNICATION_STATUSES: '/communication_statuses'
};

var GROUP_PARTNER = exports.GROUP_PARTNER = 'partner';
var GROUP_CONSUMER = exports.GROUP_CONSUMER = 'consumer';

exports.default = {
  getVersionDocuments: getVersionDocuments,
  getMissingSignatures: getMissingSignatures,
  signDocuments: signDocuments,
  getCommunicationStatuses: getCommunicationStatuses,
  updateCommunicationStatus: updateCommunicationStatus,
  getCommunicationTypes: getCommunicationTypes,
  GROUP_PARTNER: GROUP_PARTNER,
  GROUP_CONSUMER: GROUP_CONSUMER
};


function getVersionDocuments(group, params) {
  return _faustClient2.default.get({
    route: API.VERSIONED_DOCUMENTS,
    params: (0, _extends3.default)({
      group: group
    }, params)
  });
}

function getMissingSignatures(group, params) {
  return _faustClient2.default.get({
    route: API.MISSING_SIGNATURES,
    params: (0, _extends3.default)({
      group: group
    }, params)
  });
}

function signDocuments(group, documents, data) {
  return _faustClient2.default.post({
    route: API.SIGN_DOCUMENTS,
    data: (0, _extends3.default)({
      types: documents,
      group: group
    }, data)
  });
}

function getCommunicationTypes(group, params) {
  return _faustClient2.default.get({
    route: API.COMMUNICATION_TYPES,
    params: (0, _extends3.default)({
      group: group
    }, params)
  });
}

function getCommunicationStatuses(group, params) {
  return _faustClient2.default.get({
    route: API.COMMUNICATION_STATUSES,
    params: (0, _extends3.default)({
      group: group
    }, params)
  });
}

function updateCommunicationStatus(type, isEnabled, data) {
  return _faustClient2.default.post({
    route: API.COMMUNICATION_STATUSES,
    data: (0, _extends3.default)({
      type: type,
      value: isEnabled
    }, data)
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/privacy/index.js
// module id = 1199
// module chunks = 0